"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("@emotion/react");
var _react2 = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _Card = _interopRequireDefault(require("../Card"));
var _Text = _interopRequireDefault(require("../Text"));
var _UnitIllustration = _interopRequireDefault(require("../UnitIllustration"));
var _preemption = require("../private/preemption");
var _Divider = _interopRequireDefault(require("../Divider"));
var _Header = _interopRequireDefault(require("../Header"));
var _format = require("../../utils/format");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const PreemptionCard = ({
  preemption,
  onClick,
  showSizeDetails = false
}) => {
  const theme = (0, _react.useTheme)();
  const Kvm = (0, _jsxRuntime.jsx)("sup", {
    children: "2"
  });
  return (0, _jsxRuntime.jsxs)(_Card.default, {
    onClick: () => onClick(preemption.id),
    withhover: true,
    shadow: true,
    children: [(0, _jsxRuntime.jsx)(_styles.SvgHead, {
      css: /*#__PURE__*/(0, _react.css)({
        background: 'linear-gradient(' + theme.backgroundColor + ', ' + theme.backgroundColor + '), linear-gradient(' + theme.primary20opa + ', ' + theme.primary20opa + ')'
      }, process.env.NODE_ENV === "production" ? "" : ";label:PreemptionCard;"),
      children: (0, _jsxRuntime.jsx)(_UnitIllustration.default, {
        type: preemption.unit.building?.buildingCode || preemption.unit.buildingCode
      })
    }), preemption.isInternal && (0, _jsxRuntime.jsx)(_styles.InternalTag, {
      title: (0, _format.getFormattedDate)(preemption.deadline),
      children: "Intern forkj\xF8p"
    }), (0, _jsxRuntime.jsxs)(_styles.UnitInfo, {
      children: [(0, _jsxRuntime.jsxs)(_Text.default, {
        small: true,
        subtle: true,
        children: [(0, _preemption.getAreaTextForPreemptionUnit)(preemption.unit), " -", ' ', preemption.unit.building?.buildingCode || preemption.unit.buildingCode, showSizeDetails && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [preemption.unit.numberOfRooms ? ' / ' + preemption.unit.numberOfRooms + '-roms' : null, preemption.unit.primaryRoom ? ' / ' + preemption.unit.primaryRoom + ' m' : null, preemption.unit.primaryRoom ? Kvm : null]
        })]
      }), (0, _jsxRuntime.jsx)(_Text.default, {
        bold: true,
        children: preemption.unit.address
      }), (0, _jsxRuntime.jsx)(_Divider.default, {}), (0, _jsxRuntime.jsx)(_Header.default, {
        level: 5,
        children: (0, _format.getPriceWithLabel)(preemption.clarificationInAdvance, preemption.pricing)
      }), (0, _jsxRuntime.jsxs)(_Text.default, {
        small: true,
        subtle: true,
        children: ["Totalpris ", (0, _format.getFormattedPrice)(preemption.pricing.totalPrice)]
      }), (0, _jsxRuntime.jsxs)(_Text.default, {
        small: true,
        subtle: true,
        children: ["Felleskostnad ", (0, _format.getFormattedPrice)(preemption.pricing.jointCosts)]
      }), (0, _jsxRuntime.jsx)(_styles.StyledTag, {
        info: (0, _preemption.isDeadlineClosing)(preemption.deadline),
        light: !(0, _preemption.isDeadlineClosing)(preemption.deadline),
        title: (0, _format.getFormattedDate)(preemption.deadline),
        children: (0, _jsxRuntime.jsxs)(_Text.default, {
          extrasmall: true,
          children: ["MELDEFRIST:\xA0", (0, _jsxRuntime.jsx)(_Text.default, {
            extrasmall: true,
            bold: true,
            children: (0, _preemption.getMeldefristText)(preemption)
          })]
        })
      })]
    })]
  });
};
var _default = exports.default = PreemptionCard;